import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as cycleActions from '../../cycle/store/actions/cycle.actions';

@Injectable()
export class PerformanceResolver {
  constructor(private store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(cycleActions.loadData());
    return of(true);
  }
}
